<div class="container-fluid"><mat-card class="mat-card mat-focus-indicator mb-2 ">
<mat-card-title class="mat-card-title" style="font-weight: 900;">User Contact Details Verifications</mat-card-title>
<mat-card-content class="mat-card-content mt-4" style="font-size: medium;">
<p>प्रिय उपयोगकर्ता,</p>
<p>कृपया अपना <b>मोबाइल नंबर</b><b style="color: red; ">{{mobileDetail}}</b> और <b>ईमेल आईडी </b><b style="color: red; font-weight: 700;" >{{emailDetail}}</b> पुनः सत्यापित करें।</p><p><b style="color: red;">23 अगस्त 2025</b> के बाद लॉगिन ओटीपी की आवश्यकता होगी।</p>
<p>आपके खाते से जुड़ी सही ईमेल आईडी आपको अपना यूज़र आईडी या पासवर्ड भूल जाने की स्थिति में उसे पुनः प्राप्त करने में सक्षम बनाएगी।</p>
<p>किसी भी प्रकार की असुविधा की स्थिति में कृपया अपने विभाग के प्रशासक से संपर्क करें|</p>
<p>धन्यवाद!</p>
<hr><p>Dear User,</p>
<p>Please re-verify your <b>Mobile number</b><b style="color: red;"> {{mobileDetail}}</b> and <b>Email id</b><b style="color: red;"> {{emailDetail}}</b></p>
<p>Login OTP will be required after <b style="color: red;">23rd Aug 2025</b>.</p>
<p>Correct email ID associated with this account will enable you to recover your User ID or Password in case you forgot them.</p>
<p>If you notice any discrepancies, kindly contact Department Admin for assistance immediately.</p>
<p>Thank you!</p>
<div style="display:flex;flex-direction:row;justify-content:space-between">
<p style="color: #888; font-weight: 300; font-size: small;">Click anywhere outside popup to exit.</p>
<button style="    background-color: blue;
    color: white;
    border-radius: 5px;
    border: none;
" (click)="downloadFile()">To Change/Update Mobile no. and Email id SOP</button>
</div>
</mat-card-content>
</mat-card>
</div>
